import React, { useEffect, useState } from "react";
import CONFIG from "../../utils/config";
import API_LIST from "../../utils/apiList";
import {
  clickStreamUser,
  convertTimeFormat,
  getProcureInfo,
  goToLPDetailUtil,
  ProductCardPriceInfo,
  SessionKeys,
} from "../../utils/AppUtils";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  getNONOBLPListing,
  getNONOBLPListingClear,
} from "../../redux/learningPath/actions";
import _ from "lodash";
import { useTranslation } from "react-i18next";
import ActionPathCard from "../components/card/ActionPathCard";
import ProductCardFinwell from "../components/card/ProductCardFinwell";
import { duration } from "moment";
import Slider from "react-slick";

const ActionPathExploreComp = (props) => {
  const {
    selectedCategory,
    activeTab,
    viewMoreActionPath,
    setViewMoreActionPath,
    lpResult,
    fromGlobal = false,
    categoryHidden,
    setCategoryHidden = () => {},
    selectedContentType,
    setSelectedContentType = () => {},
  } = props;
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const nonOblpListing = useSelector(
    (state) => state.learningPath.nonOblpListing,
  );
  const authBroker = useSelector((state) => state.auth.authBroker);
  const [lPListing, setLPListing] = useState([]);
  const [loading, setLoading] = useState(true);
  const [viewAllClicked, setViewAllClicked] = useState(false);

  useEffect(() => {
    if (!fromGlobal) {
      fetchNonOBLPList();
    } else {
      formatLPData(lpResult);
    }
  }, [
    activeTab,
    selectedCategory,
    viewMoreActionPath,
    lpResult,
    categoryHidden,
  ]);

  const fetchNonOBLPList = () => {
    console.log("FETCH NON OBLP LIST");
    const selectedCate = selectedCategory.map((v) => v.value);
    dispatch(
      getNONOBLPListing({
        URL: `${CONFIG.API_URL_BROKER}${API_LIST.BROKER_API.GET_ALL_LP_LISTING}`,
        payload: {
          token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          sort: 0,
          page_size: 100,
          page: 0,
          search: "",
          is_onboarding: 0,
          provider_id: "",
          isAll: true, //viewMoreActionPath? viewMoreActionPath: categoryHidden,
          language: "",
          category_id: [...selectedCate],
          pillar_id: activeTab === "all" ? "" : activeTab,
        },
        isJSON: true,
        method: "post",
      }),
    );
  };

  useEffect(() => {
    if (!_.isEmpty(nonOblpListing) && !fromGlobal) {
      let responseList = nonOblpListing;

      console.log(nonOblpListing);
      if (responseList.status === "success") {
        const payload = responseList.payload?.data;
        if (!_.isEmpty(payload)) {
          console.log(payload);
          formatLPData(payload?.records);
        } else {
          setLPListing([]);
        }
      } else {
        setLPListing([]);
      }

      dispatch(getNONOBLPListingClear());
    }
  }, [nonOblpListing]);

  const formatLPData = (lpData) => {
    console.log("lpData", lpData);
    let lpArr = [];
    let records = lpData;
    for (let lp of records) {
      let tags = [];
      let logoURL = "";
      let btnTitle = t("Explore");
      if (_.toNumber(lp.learn_progress) === 100) {
        btnTitle = t("Revisit");
      }
      if (
        _.toNumber(lp.learn_progress) > 1 &&
        _.toNumber(lp.learn_progress) < 100
      ) {
        btnTitle = t("resume");
      }
      if (!_.isEmpty(lp.provider)) {
        tags.push(lp.provider.provider_display_name);
        logoURL = lp.provider.provider_img;
      }

      if (lp.product_type === "bundle") {
        tags.push(t("Combo"));
      } else {
        tags.push(t(`Action Path`));
      }

      if (lp.learningpath_count) {
        tags.push(
          `${lp.learningpath_count} ${t("Action Path")}${
            lp.learningpath_count > 1 ? "s" : ""
          }`,
        );
      }
      if (lp.course_count) {
        tags.push(
          `${lp.course_count} ${t("Course")}${lp.course_count > 1 ? "s" : ""}`,
        );
      }
      if (lp.video_count) {
        tags.push(
          `${lp.video_count} ${t("Video")}${lp.video_count > 1 ? "s" : ""}`,
        );
      }
      if (lp.level_count) {
        tags.push(
          `${lp.level_count} ${t("Level")}${lp.level_count > 1 ? "s" : ""}`,
        );
      }
      if (lp.event_count) {
        tags.push(
          `${lp.event_count} ${t("Event")}${lp.event_count > 1 ? "s" : ""}`,
        );
      }
      if (lp.duration) {
        tags.push(`${convertTimeFormat(lp.duration, true, t)}`);
      }
      let priceInfo = getProcureInfo(lp.purchased_info);
      lp.priceInfo = priceInfo;

      // Pick a random color from the array for each card
      const colors = ["pink-c", "yellow-c", "blue-c"];
      const randomColor = colors[Math.floor(Math.random() * colors.length)];

      lpArr.push({
        id: lp?.id,
        ecom_id: lp?.ecom_id,
        is_like: lp?.is_like ? lp?.is_like : false,
        is_bookmark: lp?.is_bookmark ? lp?.is_bookmark : false,
        is_wishlist: lp?.is_addtowishlist,
        dbId: lp?.list_id,
        productType: "learningpath",
        productOrigin: lp?.origin,
        title: lp.name,
        lp_name: lp.name,
        logoURL: logoURL,
        logoAlText: "LP",
        bannerURL: lp.thumbnail,
        thumbnail: lp.thumbnail,
        tagsArray: tags,
        description: lp.short_description,
        duration: convertTimeFormat(lp.duration, false, t),
        showHeader: true,
        showProviderIcon: true,
        showLikeMenu: true,
        showPlayButton: false,
        showProgress: false,
        showBody: false,
        showFooter: true,
        progress: lp.learn_progress,
        btnTitle: btnTitle,
        btnAction: () => goToLPDetailUtil(lp, navigate, 0),
        descAction: () => {},
        bannerAction: () => goToLPDetailUtil(lp, navigate, 0),
        shareClicked: () => goToLPDetailUtil(lp, navigate, 0, "share"),
        cardClassName: "",
        footerLineComp: !_.isEmpty(priceInfo)
          ? ProductCardPriceInfo(priceInfo.showText, priceInfo.textColor)
          : "",
        isLoading: false,
        priceInfo: priceInfo,
        rightBtnIcon: "/images/arrow-right.svg",
        lefttBtnIcon: "",
        isBundle: lp?.product_type === "bundle",
        bundles: lp?.bundles,
        status: lp?.status,
        color: randomColor, // assign the random color
        is_level: false,
        source: "broker",
        origin: "broker",
        ob_lp: "0",
        product_type: "learningpath",
        category_name: lp?.category_name,
        asset_type: t(`Action Path`),
        asset_name: lp?.asset_name,
        asset_id: lp?.asset_id,
        is_ob_lp: "0",
        monitoring_name: lp?.monitoring_name,
        cover_url: lp?.cover_url,
        asset_icon: "/images/finwell-img/extension.svg",
        monitoring_icon: lp?.monitoring_icon,
        isCoachPick: lp?.is_coachpick,
        fromPage:"explore"
      });
    }

    setLPListing(lpArr);
  };

  function isActionpathExpanded(categoryHidden) {
    if (categoryHidden) {
      setSelectedContentType((prev) =>
        prev.filter((item) => item.value !== "10"),
      );
    } else {
      setSelectedContentType((prev) => [
        ...prev,
        {
          value: "10",
          label: t("Action Path"),
        },
      ]);
    }
  }
  console.log("lPListing", viewMoreActionPath, categoryHidden);
  const ActionPath = {
    dots: true,
    arrows: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 3,
    infinite: false,
    responsive: [
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: false,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  useEffect(() => {
    setTimeout(() => {
      window.dispatchEvent(new Event("resize"));
    }, 500);
  }, []);

  return (
    <>
      <section className="mb-2rem section-block">
        {!_.isEmpty(lPListing) && lPListing?.length > 0 && (
          <div class="continue-section">
            <div class="left">
              <h3>{t("action_paths")}</h3>
              <p>{t("Expert-curated action steps to achieve more mastery")}</p>
            </div>
            {!_.isEmpty(lPListing) &&
              lPListing?.length > 0 &&
              !categoryHidden && (
                <div class="right">
                  <a
                    className="cursor-pointer"
                    tabIndex={0}
                    aria-label="View more"
                    onClick={() => {
                      clickStreamUser(
                        "view_more_clicked",
                        {
                          userId: authBroker?.payload?.user?.user_id,
                        },
                        authBroker,
                      );
                      setCategoryHidden(!categoryHidden);
                      isActionpathExpanded(categoryHidden);
                      if (fromGlobal) {
                        navigate("/explore?pillar_id=all");
                      } else {
                        setViewMoreActionPath(!viewMoreActionPath);
                      }
                    }}
                  >
                    {t("view_more")}
                  </a>
                </div>
              )}
          </div>
        )}

        {viewMoreActionPath || categoryHidden ? (
          <>
            <div className="row">
              {lPListing.map((course, i) => {
                console.log("COURSE334454", course);
                return (
                  <div className="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-12 mb-3">
                    <ProductCardFinwell {...course} key={`course-${i + 1}`} componentKey={`action-path-explore-${i}`} />
                  </div>
                );
              })}
            </div>
          </>
        ) : (
          <Slider key={lPListing.length} {...ActionPath} className="slider-gap">
            {lPListing.map((action, index) => (
              <ActionPathCard
                key={action.id || index}
                index={index}
                action={action}
                componentKey={`action-path-slider-${index}`}
              />
            ))}
          </Slider>
        )}
      </section>
    </>
  );
};

export default ActionPathExploreComp;
